// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function GlobeHemisphereEastIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M16 3a13 13 0 1 0 13 13A13.013 13.013 0 0 0 16 3Zm0 2a10.938 10.938 0 0 1 6 1.785V9.25l-2.771 3.217-3.934.533-.039-.027-2.459-1.608a2 2 0 0 0-2.813.522L7.366 15.8a2 2 0 0 0-.337 1.101L7 21.43l-.409.269A11 11 0 0 1 16 5ZM7.786 23.309l.315-.207A2 2 0 0 0 9 21.442l.026-4.53L11.646 13c.013.01.026.02.04.027l2.459 1.61c.412.29.92.414 1.419.345l3.936-.533a2 2 0 0 0 1.25-.676l2.771-3.22A2 2 0 0 0 24 9.25v-.791a10.984 10.984 0 0 1 2.471 10.916l-2.017-1.845a2 2 0 0 0-2.117-.375l-3.807 1.581a2.011 2.011 0 0 0-1.21 1.556l-.299 2.024a2 2 0 0 0 1.471 2.227l2.683.707.295.296A10.985 10.985 0 0 1 7.786 23.31Zm15.339 1.066-.538-.539a2 2 0 0 0-.907-.522L19 22.606l.299-2.024L23.105 19l2.52 2.31a11.055 11.055 0 0 1-2.5 3.065Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
